module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes--6--a-938b84fa.png";